<template>
  <div class="seafirmscont">
    <div class="conttitle">合肥债权债务律所</div>
    <div class="contmidd between">
      <div class="seazc">
        <div class="firmslist">
          <div class="firmsitem flex_start" v-for="item in 5" :key="item">
            <div class="cover">
              <img
                src="../../../assets/search/seafirmsfircover_sample.png"
                alt=""
              />
            </div>
            <div class="Lawfirms">
              <div class="name">安徽XXX律师事务所</div>
              <div class="zhuren">
                <span>主任律师：王XX</span>
                <span class="sxs">|</span>
                <span>团队规模 ：<span class="re">86</span>人</span>
              </div>
              <div class="zy">
                专长领域：
                {{
                  `证券市场、工程及房地产、公司经营、婚姻家庭、遗产继承、房屋土地、
                民事诉讼、商事仲裁、刑事诉讼、国家赔偿` | toEllipsisFilter(70)
                }}
              </div>
              <div class="shouxia flex_start">
                <span>旗下律师：</span>
                <img
                  v-for="(i, j) in 3"
                  :key="j"
                  src="~assets/base/small_rentou.png"
                  alt=""
                />
                <img src="~assets/findlawchild/locfirgengduo.png" />
              </div>
              <div class="lianxi">立即咨询</div>
            </div>
          </div>
        </div>

        <div class="pagination mt30">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="pageCount"
            :current-page="currentPage"
            :pager-count="5"
            @current-change="turnpage"
            @prev-click="turnpage(--currentPage)"
            @next-click="turnpage(++currentPage)"
          >
          </el-pagination>
        </div>
      </div>
      <div class="searc">
        <speltfocblem class="common" />
        <findlawtip class="common mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import speltfocblem from "views/speciallist/components/speltfocblem";
import findlawtip from "../components/findlawtip";
export default {
  components: {
    speltfocblem,
    findlawtip
  },
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
  }),
  methods: {
    turnpage(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.seafirmscont {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 70px;
  .conttitle {
    font-size: 20px;
    color: #333333;
    margin-bottom: 30px;
  }
  .contmidd {
    align-items: flex-start;
    .common {
        background: #ffffff;
      }
    .seazc {
      width: 856px;
      padding-bottom: 50px;
      background-color: #fff;

      .firmslist {
        .firmsitem {
          padding: 24px 32px;
          position: relative;
          cursor: pointer;
          align-items: flex-start;
          .cover {
            margin-right: 30px;
            img {
              width: 270px;
              height: 160px;
            }
          }
          .Lawfirms {
            .name {
              font-size: 18px;
              color: #333333;
            }
            .zhuren {
              margin-top: 14px;
              font-size: 14px;
              color: #666666;
              .re {
                color: #e30000;
              }
              .sxs {
                margin: 0 20px;
              }
            }
            .zy {
              margin-top: 14px;
              font-size: 12px;
              height: 44px;
              color: #999999;
              line-height: 22px;
            }
            .shouxia {
              margin-top: 12px;
              font-size: 14px;
              color: #999999;
              img {
                cursor: pointer;
                width: 36px;
                height: 36px;
                border-radius: 50%;
                margin-right: 6px;
              }
            }
            .lianxi {
              position: absolute;
              bottom: 15px;
              transform: translateY(-50%);
              text-align: center;
              right: 32px;
              width: 94px;
              height: 30px;
              line-height: 30px;
              background: #ffffff;
              border: 1px solid #0465ea;
              border-radius: 18px;
              font-size: 14px;
              color: #0465ea;
            }
          }

          &:last-child {
            border-bottom: none;
          }
          &:hover {
            box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
          }
        }
      }

      .pagination {
        text-align: center;
        ::v-deep .el-pagination.is-background .btn-next,
        ::v-deep .el-pagination.is-background .btn-prev,
        ::v-deep .el-pagination button,
        ::v-deep .el-pagination span:not([class*="suffix"]),
        ::v-deep .el-pagination.is-background .el-pager li {
          min-width: 36px;
          height: 36px;
          line-height: 36px;
        }
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled).active,
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled):hover {
          color: #ffffff !important;
          background: #0057ff !important;
        }
      }
    }
    .searc {
      width: 314px;
    }
  }
}
</style>